// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__2G6i-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/UI/Modal/Modal.css
// module id = 117
// module chunks = 3